import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import KeysDevice from "./KeysDevice";
import { withRouter } from "react-router-dom";

import {
  load,
  setFiltro,
  buscar,
  toggleDevice,
  remove,
  qsort,
  getKeysDevice,
  cleanDeviceKey,
} from "../../actions/dispositivo/CoDispositivo";
import { Carregando, Alert } from "../../components";
const moment = require("moment");

class CoDispositivo extends Component {
  componentWillMount() {
    this.carregar();
  }

  state = {
    showKeysDialog: false,
  };

  render() {
    let { expressao, isFetching, match } = this.props;
    let { conta } = match.params;

    return (
      <span>
        <Alert
          ref={(ref) => {
            this._alert = ref;
          }}
        />
        <Carregando isOpen={isFetching} />
        <KeysDevice
          isOpen={this.state.showKeysDialog}
          onClose={() => this.cleanKeys()}
        />
        <div className="pt-callout .modifier">
          <h5>Registro de dispositivos {conta}</h5>
        </div>
        <nav className="pt-navbar .modifier">
          <div className="pt-navbar-group pt-align-left">
            <div className="pt-navbar-heading">Expressão para consulta:</div>
            <input
              className="pt-input"
              placeholder="Buscar..."
              type="text"
              value={expressao}
              onChange={({ target }) => {
                this.setFiltro({ expressao: target.value });
              }}
            />
            <span className="pt-navbar-divider"></span>
            <button
              className="pt-button pt-intent-primary"
              onClick={() => {
                this.buscar();
              }}
            >
              Consultar
            </button>
            <span className="pt-navbar-divider"></span>
            <button
              className="pt-button"
              onClick={() => {
                this.voltar();
              }}
            >
              Voltar
            </button>
          </div>
          <div className="pt-navbar-group pt-align-right"></div>
        </nav>
        <div className="pt-card .modifier">
          <table className="pt-table pt-striped pt-interactive" width="100%">
            <thead>
              <tr>{this.renderTableHead()}</tr>
            </thead>
            <tbody>{this.renderDataSource()}</tbody>
          </table>
        </div>
        <div className="pt-callout pt-intent-primary">
          <h5>Senha para limpar base</h5>
          Total = {this.getSenhaTotal()} | Parcial (manter pedidos) ={" "}
          {this.getSenhaParcial()}
        </div>
      </span>
    );
  }

  renderTableHead() {
    let { sort } = this.props;

    let head = [
      { key: "#", label: "#" },
      { key: "user", label: "Usuário", onClick: () => this.qsort("user") },
      { key: "vm", label: "VM", onClick: () => this.qsort("vm") },
      { key: "version", label: "Versão", onClick: () => this.qsort("version") },
      {
        key: "platform",
        label: "Plataforma",
        onClick: () => this.qsort("platform"),
      },
      {
        key: "model",
        label: "Dispositivo",
        onClick: () => this.qsort("model"),
      },
      {
        key: "guid",
        label: "Identificador",
        onClick: () => this.qsort("guid"),
      },
      {
        key: "registered_at",
        label: "Registrado",
        onClick: () => this.qsort("registered_at"),
      },
      {
        key: "updated_at",
        label: "Atualizado",
        onClick: () => this.qsort("updated_at"),
      },
      { key: "active", label: "Situação", onClick: () => this.qsort("active") },
      { key: "ativar", label: "Ativar/Desativar" },
      { key: "log", label: "Log" },
      { key: "excluir", label: "Excluir" },
    ];

    let icon = <span className="pt-icon pt-icon-caret-up" />;
    if (sort.asc) {
      icon = <span className="pt-icon pt-icon-caret-down" />;
    }

    return head.map((item, index) => {
      return (
        <th
          key={index}
          onClick={item.onClick}
          style={{ cursor: item.onClick ? "pointer" : "default" }}
        >
          {item.label} {sort.property === item.key ? icon : null}
        </th>
      );
    });
  }

  renderDataSource() {
    let { dataSource } = this.props;

    if (dataSource && dataSource.length > 0) {
      return dataSource.map((item, index) => {
        return (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td>{item.user}</td>
            <td>{item.vm}</td>
            <td>{item.version}</td>
            <td>{item.platform}</td>
            <td>{item.model}</td>
            <td>
              <a
                onClick={() =>
                  this.showKeys(this.props.match.params.conta, item.id)
                }
              >
                {" "}
                {item.guid}
              </a>
            </td>
            <td>
              {moment(item.registered_at)
                .add(-3, "h")
                .format("DD/MM/YYYY HH:mm:ss")}
            </td>
            <td>
              {moment(item.updated_at)
                .add(-3, "h")
                .format("DD/MM/YYYY HH:mm:ss")}
            </td>
            <td>{item.active ? "Ativo" : "Inativo"}</td>
            <td>
              <a
                onClick={() => {
                  this.toggleDevice(item.id);
                }}
              >
                {item.active ? "Desativar" : "Ativar"}
              </a>
            </td>
            <td>
              <a>Log</a>
            </td>
            <td>
              <a
                onClick={() => {
                  this.excluir(item.id);
                }}
              >
                Excluir
              </a>
            </td>
          </tr>
        );
      });
    }

    return (
      <tr key="vazio">
        <td colSpan="13">Nenhum registro encontrado!</td>
      </tr>
    );
  }

  cleanKeys() {
    this.setState({ showKeysDialog: false }, () => {
      this.props.cleanDeviceKey();
    });
  }

  showKeys(account, id) {
    let obj = {
      account,
      id,
    };

    this.props.getKeysDevice(obj, () => {
      this.setState({ showKeysDialog: true });
    });
  }
  getSenhaTotal() {
    let data = new Date();
    return parseInt((data.getDate() * 301) / 57, 10);
  }

  getSenhaParcial() {
    let data = new Date();
    return parseInt((data.getDate() * 101) / 55, 10);
  }

  setFiltro(value) {
    this.props.setFiltro(value);
  }

  buscar() {
    this.carregar().then(() => {
      this.props.buscar();
    });
  }

  qsort(property) {
    this.props.qsort(property);
  }

  voltar() {
    this.props.history.goBack();
  }

  toggleDevice(id) {
    this.props
      .toggleDevice(id)
      .then(() => {
        this.props.buscar();
      })
      .catch((error) => {
        this._alert.show({
          title: error.message,
          icon: "pt-icon-issue",
        });
      });
  }

  excluir(id) {
    this.props
      .remove(id)
      .then(() => {
        this.props.buscar();
      })
      .catch((error) => {
        this._alert.show({
          title: error.message,
          icon: "pt-icon-issue",
        });
      });
  }

  carregar() {
    let { conta } = this.props.match.params;
    return this.props.load(conta).catch((error) => {
      this._alert.show({
        title: error.message,
        icon: "pt-icon-issue",
      });
    });
  }
}

function mapStateToProps(state) {
  let { dataSource, expressao, isFetching, sort } = state.coDispositivo;

  return {
    dataSource,
    expressao,
    isFetching,
    sort,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      load,
      setFiltro,
      buscar,
      toggleDevice,
      remove,
      qsort,
      getKeysDevice,
      cleanDeviceKey,
    },
    dispatch,
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CoDispositivo),
);



// WEBPACK FOOTER //
// ./src/scenes/dispositivo/CoDispositivo.js